import { RolesProvider } from '../context';
import React from 'react';
import { RolesTable } from './List/RolesTable';
import { Detail } from './Form';
import { Authorize } from '@/core';
import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import RolesTableFilter from './List/RolesTableFilter';
import { PERMISSIONS } from '@/contants';

export const RolesListScreen: React.FC<unknown> = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();
  return (
    <>
      <RolesProvider>
        <div className='bg-white py-10 px-lg-16 flex flex-col flex-wrap'>
          <div>
            <RolesTableFilter handleCreate={handleClickCreate} />
            <RolesTable />
            <Detail open={open} handleClose={handleClose} setOpen={setOpen} />
          </div>
        </div>
      </RolesProvider>
    </>
  );
};

export const RolesList = Authorize<unknown>(RolesListScreen, PERMISSIONS.ROLES.VIEW);
